<template>
  <BCol md="5" v-if="audioBook">
    <BRow>
      <BCol cols="12" v-if="audioBook.book">
        <h4 class="font-weight-bold">
          {{ audioBook.book.title }}
        </h4>
      </BCol>
    </BRow>
    <BRow class="mb-3">
      <BCol cols="12">
        <h5>
          {{ audioBook.author }}
        </h5>
      </BCol>
    </BRow>
    <BRow class="mb-3">
      <BCol cols="12">
        <div>
          <span class="font-weight-bold">ISBN</span>
          <span>
          {{ audioBook.isbn }}
          </span>
        </div>
        <div>
        <span class="font-light">
          {{ audioBook.publisher }}
        </span>
        </div>
      </BCol>
    </BRow>
  </BCol>
</template>

<script>
import * as audioBookGetters from "../../../../store/modules/AudioBook/types/getters";
import { mapGetters } from "vuex";

export default {
  name: "InfoForAudio",
  props: {
    currentChapter: Object
  },
  computed: {
    ...mapGetters('AudioBook', {
      audioBook: audioBookGetters.GET_AUDIO_BOOK
    })
  }
}
</script>